import "./cameraEditor.1acb9652.js";
import "./cameraEditor.bd798f01.js";
import "./cameraEditor.4b8d4fc8.js";
import "./cameraEditor.737f6996.js";


function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire1149"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire1149"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("82VHk", function(module, exports) {

$parcel$export(module.exports, "default", () => $5dbb4439cfbde5f7$export$2e2bcd8739ae039);
var $5dbb4439cfbde5f7$var$Stats = function() {
    var mode = 0;
    var container = document.createElement('div');
    container.style.cssText = 'position:fixed;top:0;left:0;cursor:pointer;opacity:0.9;z-index:10000';
    container.addEventListener('click', function(event) {
        event.preventDefault();
        showPanel(++mode % container.children.length);
    }, false);
    //
    function addPanel(panel) {
        container.appendChild(panel.dom);
        return panel;
    }
    function showPanel(id) {
        for(var i = 0; i < container.children.length; i++)container.children[i].style.display = i === id ? 'block' : 'none';
        mode = id;
    }
    //
    var beginTime = (performance || Date).now(), prevTime = beginTime, frames = 0;
    var fpsPanel = addPanel(new $5dbb4439cfbde5f7$var$Stats.Panel('FPS', '#0ff', '#002'));
    var msPanel = addPanel(new $5dbb4439cfbde5f7$var$Stats.Panel('MS', '#0f0', '#020'));
    if (self.performance && self.performance.memory) var memPanel = addPanel(new $5dbb4439cfbde5f7$var$Stats.Panel('MB', '#f08', '#201'));
    showPanel(0);
    return {
        REVISION: 16,
        dom: container,
        addPanel: addPanel,
        showPanel: showPanel,
        begin: function() {
            beginTime = (performance || Date).now();
        },
        end: function() {
            frames++;
            var time = (performance || Date).now();
            msPanel.update(time - beginTime, 200);
            if (time >= prevTime + 1000) {
                fpsPanel.update(frames * 1000 / (time - prevTime), 100);
                prevTime = time;
                frames = 0;
                if (memPanel) {
                    var memory = performance.memory;
                    memPanel.update(memory.usedJSHeapSize / 1048576, memory.jsHeapSizeLimit / 1048576);
                }
            }
            return time;
        },
        update: function() {
            beginTime = this.end();
        },
        // Backwards Compatibility
        domElement: container,
        setMode: showPanel
    };
};
$5dbb4439cfbde5f7$var$Stats.Panel = function(name, fg, bg) {
    var min = Infinity, max = 0, round = Math.round;
    var PR = round(window.devicePixelRatio || 1);
    var WIDTH = 80 * PR, HEIGHT = 48 * PR, TEXT_X = 3 * PR, TEXT_Y = 2 * PR, GRAPH_X = 3 * PR, GRAPH_Y = 15 * PR, GRAPH_WIDTH = 74 * PR, GRAPH_HEIGHT = 30 * PR;
    var canvas = document.createElement('canvas');
    canvas.width = WIDTH;
    canvas.height = HEIGHT;
    canvas.style.cssText = 'width:80px;height:48px';
    var context = canvas.getContext('2d');
    context.font = 'bold ' + 9 * PR + 'px Helvetica,Arial,sans-serif';
    context.textBaseline = 'top';
    context.fillStyle = bg;
    context.fillRect(0, 0, WIDTH, HEIGHT);
    context.fillStyle = fg;
    context.fillText(name, TEXT_X, TEXT_Y);
    context.fillRect(GRAPH_X, GRAPH_Y, GRAPH_WIDTH, GRAPH_HEIGHT);
    context.fillStyle = bg;
    context.globalAlpha = 0.9;
    context.fillRect(GRAPH_X, GRAPH_Y, GRAPH_WIDTH, GRAPH_HEIGHT);
    return {
        dom: canvas,
        update: function(value, maxValue) {
            min = Math.min(min, value);
            max = Math.max(max, value);
            context.fillStyle = bg;
            context.globalAlpha = 1;
            context.fillRect(0, 0, WIDTH, GRAPH_Y);
            context.fillStyle = fg;
            context.fillText(round(value) + ' ' + name + ' (' + round(min) + '-' + round(max) + ')', TEXT_X, TEXT_Y);
            context.drawImage(canvas, GRAPH_X + PR, GRAPH_Y, GRAPH_WIDTH - PR, GRAPH_HEIGHT, GRAPH_X, GRAPH_Y, GRAPH_WIDTH - PR, GRAPH_HEIGHT);
            context.fillRect(GRAPH_X + GRAPH_WIDTH - PR, GRAPH_Y, PR, GRAPH_HEIGHT);
            context.fillStyle = bg;
            context.globalAlpha = 0.9;
            context.fillRect(GRAPH_X + GRAPH_WIDTH - PR, GRAPH_Y, PR, round((1 - value / maxValue) * GRAPH_HEIGHT));
        }
    };
};
var $5dbb4439cfbde5f7$export$2e2bcd8739ae039 = $5dbb4439cfbde5f7$var$Stats;

});


var $jw0R5 = parcelRequire("jw0R5");

var $ihXk0 = parcelRequire("ihXk0");

var $2sw9m = parcelRequire("2sw9m");

var $82VHk = parcelRequire("82VHk");

var $ctZJO = parcelRequire("ctZJO");

var $6BOAB = parcelRequire("6BOAB");

var $cPutt = parcelRequire("cPutt");
const $01713220afa8b7f5$var$DEFAULT_CONFIG = {
    distance: 1000,
    duration: 1.0,
    easingName: 'Linear',
    easingType: 'In',
    frameRate: 30,
    allowQueue: true
};
const $01713220afa8b7f5$var$DEFAULT_CALLBACKS = {
    onStart: null,
    onFinish: null,
    onStep: null
};
class $01713220afa8b7f5$export$836250ae3b3bff57 {
    constructor(options = {}){
        this.config = {
            ...$01713220afa8b7f5$var$DEFAULT_CONFIG
        };
        this.callbacks = {
            ...$01713220afa8b7f5$var$DEFAULT_CALLBACKS
        };
        this.floors = [];
        this.floorNumbers = [];
        this.floorsStatus = 'normal';
        this.lastFloorIndex = Number.POSITIVE_INFINITY;
        this.status = 'idle';
        this.activeAnimation = null;
        this.pendingLevels = [];
        if (options.callbacks) this.setCallbacks(options.callbacks);
        this.setConfig(options);
        if (options.floors?.length > 0) this.bindFloors(options.floors, options.floorNumbers);
    }
    bindFloors(floors = [], floorNumbers = null) {
        /*
         * Expected floors input:
         * - floors: Array<Object3D>, each item is one floor group.
         * - floor.userData format (recommended):
         *   - userData.name: string like "Floor.3" (used to infer floor number if floorNumbers is not provided).
         *   - userData.originY: number, original Y position of this floor.
         *   - userData.status: "normal" | "rised", current motion status.
         *   - userData.progress: number in [0, 1], normalized animation progress.
         * The controller will initialize/overwrite originY/status/progress to ensure deterministic animation state.
         */ this.floors = floors;
        this.floorNumbers = floorNumbers?.length > 0 ? floorNumbers.slice() : this.floors.map((floor, index)=>{
            const rawName = floor?.userData?.name;
            if (typeof rawName === 'string' && rawName.includes('.')) {
                const parsed = Number(rawName.split('.')[1]);
                if (Number.isFinite(parsed)) return parsed;
            }
            return index;
        });
        this.floors.forEach((floor)=>{
            if (!floor.userData) floor.userData = {};
            floor.userData.originY = floor.position.y;
            floor.userData.status = 'normal';
            floor.userData.progress = 0;
        });
        this.reset();
        return this;
    }
    setConfig(partial = {}) {
        this.config.distance = partial.distance ?? this.config.distance;
        this.config.frameRate = Math.max(1, partial.frameRate ?? this.config.frameRate);
        this.config.duration = Math.max(1e-4, partial.duration ?? this.config.duration);
        if (partial.scale !== undefined) {
            const safeScale = Math.max(1e-6, partial.scale);
            this.config.duration = 1 / (this.config.frameRate * safeScale);
        }
        this.config.easingName = partial.easingName ?? this.config.easingName;
        this.config.easingType = partial.easingType ?? this.config.easingType;
        this.config.allowQueue = partial.allowQueue ?? this.config.allowQueue;
        return this;
    }
    setCallbacks(callbacks = {}) {
        Object.assign(this.callbacks, callbacks);
        return this;
    }
    getFrameDuration() {
        return 1 / this.config.frameRate;
    }
    isAnimating() {
        return this.status === 'animating' && !!this.activeAnimation;
    }
    moveToLevel(level, options = {}) {
        const { force: force = false, queue: queue = this.config.allowQueue } = options;
        const floorIndex = this.floorNumbers.indexOf(level);
        if (floorIndex < 0) return false;
        if (this.isAnimating() && !force) {
            if (queue) this.pendingLevels.push(level);
            return false;
        }
        return this._startForFloorIndex(floorIndex, level);
    }
    update(deltaSec = this.getFrameDuration()) {
        if (!this.isAnimating()) return {
            changed: false,
            finished: false
        };
        const delta = Math.max(0, deltaSec);
        const { floorGroups: floorGroups, direction: direction, distance: distance, duration: duration, easingEval: easingEval } = this.activeAnimation;
        const length = floorGroups.length;
        const progressStep = delta / duration;
        if (direction === 'up') floorGroups.forEach((floor, index)=>{
            const { progress: progress, originY: originY } = floor.userData;
            if (progress >= 1) return;
            const eased = easingEval(progress);
            floor.position.y = originY + distance * eased;
            // Apply per-floor weighted speed and clamp to [0, 1] normalized progress.
            const nextProgress = Math.min(1, progress + progressStep * (0.4 + 2 * (index + 1) / length));
            floor.userData.progress = nextProgress;
            if (nextProgress >= 1) {
                floor.position.y = originY + distance;
                floor.userData.status = 'rised';
            }
        });
        else floorGroups.forEach((floor, index)=>{
            const { progress: progress, originY: originY } = floor.userData;
            if (progress >= 1) return;
            const eased = easingEval(progress);
            floor.position.y = originY + distance * (1 - eased);
            const nextProgress = Math.min(1, progress + progressStep * (0.4 + 2 * (length - index) / length));
            floor.userData.progress = nextProgress;
            if (nextProgress >= 1) {
                floor.position.y = originY;
                floor.userData.status = 'normal';
            }
        });
        const finished = floorGroups.every((floor)=>floor.userData.progress === 1);
        this.callbacks.onStep?.({
            finished: finished,
            direction: direction,
            groupCount: floorGroups.length
        });
        if (finished) this._finishActiveAnimation();
        return {
            changed: true,
            finished: finished
        };
    }
    pause() {
        if (this.isAnimating()) this.status = 'paused';
        return this;
    }
    resume() {
        if (this.status === 'paused' && this.activeAnimation) this.status = 'animating';
        return this;
    }
    stop(clearQueue = false) {
        this.activeAnimation = null;
        this.status = 'idle';
        if (clearQueue) this.pendingLevels.length = 0;
        return this;
    }
    reset(groups = this.floors) {
        this.stop(false);
        this.floorsStatus = 'normal';
        this.lastFloorIndex = Number.POSITIVE_INFINITY;
        groups.forEach((floor)=>{
            floor.position.y = floor.userData.originY;
            floor.userData.status = 'normal';
            floor.userData.progress = 0;
        });
        return this;
    }
    getSnapshot() {
        return {
            status: this.status,
            floorsStatus: this.floorsStatus,
            isAnimating: this.isAnimating(),
            pendingCount: this.pendingLevels.length,
            hasActiveAnimation: !!this.activeAnimation
        };
    }
    getOperableLevels() {
        const uniqueLevels = Array.from(new Set(this.floorNumbers.filter((level)=>Number.isFinite(level)))).sort((a, b)=>a - b);
        return uniqueLevels;
    }
    _startForFloorIndex(floorIndex, level) {
        if (this.floors.every((floor)=>floor.userData.status === 'normal')) this.reset();
        let direction = 'up';
        let groups = [];
        if (this.floorsStatus === 'normal') {
            groups = this._selectGroups(floorIndex, 'up');
            if (groups.length > 0) {
                this.floorsStatus = 'expanded';
                direction = 'up';
            }
        } else if (this.floorsStatus === 'expanded') {
            direction = level < this.floorNumbers[this.lastFloorIndex] ? 'up' : 'down';
            groups = this._selectGroups(floorIndex, direction);
        }
        this.lastFloorIndex = floorIndex;
        this._startAnimation(groups, direction);
        return true;
    }
    _startAnimation(floorGroups, direction) {
        floorGroups.forEach((floor)=>{
            floor.userData.progress = 0;
        });
        if (floorGroups.length === 0) {
            this.status = 'idle';
            this.activeAnimation = null;
            return;
        }
        this.status = 'animating';
        this.activeAnimation = {
            floorGroups: floorGroups,
            direction: direction,
            distance: this.config.distance,
            duration: this.config.duration,
            easingEval: this._resolveEasing(this.config.easingName, this.config.easingType)
        };
        this.callbacks.onStart?.({
            direction: direction,
            groupCount: floorGroups.length
        });
    }
    _finishActiveAnimation() {
        this.activeAnimation = null;
        this.status = 'idle';
        this.callbacks.onFinish?.();
        if (this.pendingLevels.length > 0) {
            const nextLevel = this.pendingLevels.shift();
            this.moveToLevel(nextLevel, {
                force: true,
                queue: false
            });
        }
    }
    _selectGroups(floorIndex, direction) {
        if (direction === 'up') return this.floors.filter((floor, index)=>{
            return floor.userData.status === 'normal' && index > floorIndex;
        });
        if (direction === 'down') return this.floors.filter((floor, index)=>{
            return floor.userData.status === 'rised' && index <= floorIndex;
        });
        return [];
    }
    _resolveEasing(easingName, easingType) {
        let easingEval = (t)=>t;
        let easingGroup = $cPutt.Easing[easingName];
        if (easingName === 'generatePow') easingGroup = easingGroup();
        if (easingGroup?.[easingType]) easingEval = easingGroup[easingType].bind(easingGroup);
        else if (easingGroup?.None) easingEval = easingGroup.None.bind(easingGroup);
        return easingEval;
    }
    static getEasingNames() {
        const names = [];
        for(const name in $cPutt.Easing)names.push(name);
        return names;
    }
}


const $cce047a9dd9eab82$var$assetUrl = (0, $6BOAB.getAssetURL)();
const $cce047a9dd9eab82$var$modelUrl = $cce047a9dd9eab82$var$assetUrl + 'models/scenes/floors.glb';
const $cce047a9dd9eab82$var$renderLoop = (0, $6BOAB.getRenderLoopController)();
let $cce047a9dd9eab82$var$camera, $cce047a9dd9eab82$var$scene, $cce047a9dd9eab82$var$renderer, $cce047a9dd9eab82$var$controls;
let $cce047a9dd9eab82$var$stats, $cce047a9dd9eab82$var$pane;
const $cce047a9dd9eab82$var$BG_COLOR = 0x333333;
const $cce047a9dd9eab82$var$FRAME_RATE = 30;
const $cce047a9dd9eab82$var$FRAME_DURATION = 1 / $cce047a9dd9eab82$var$FRAME_RATE;
let $cce047a9dd9eab82$var$windwoWidth = window.innerWidth;
let $cce047a9dd9eab82$var$windowHeight = window.innerHeight;
const $cce047a9dd9eab82$var$dimension = {
    center: new (0, $jw0R5.Vector3)(),
    min: new (0, $jw0R5.Vector3)(),
    max: new (0, $jw0R5.Vector3)()
};
let $cce047a9dd9eab82$var$floors = [];
let $cce047a9dd9eab82$var$floorNumbers = [];
let $cce047a9dd9eab82$var$motionController = null;
const $cce047a9dd9eab82$var$easingNames = (0, $01713220afa8b7f5$export$836250ae3b3bff57).getEasingNames();
const $cce047a9dd9eab82$var$params = {
    reset: $cce047a9dd9eab82$var$reset,
    distance: 1000,
    duration: 1.0,
    easingName: 'Linear',
    easingType: 'In',
    renderOnIdle: false
};
$cce047a9dd9eab82$var$init();
function $cce047a9dd9eab82$var$init() {
    $cce047a9dd9eab82$var$renderer = new (0, $jw0R5.WebGLRenderer)({
        antialias: true
    });
    $cce047a9dd9eab82$var$renderer.setPixelRatio(window.devicePixelRatio);
    $cce047a9dd9eab82$var$renderer.setSize($cce047a9dd9eab82$var$windwoWidth, $cce047a9dd9eab82$var$windowHeight);
    $cce047a9dd9eab82$var$renderer.setClearColor($cce047a9dd9eab82$var$BG_COLOR, 1);
    document.body.appendChild($cce047a9dd9eab82$var$renderer.domElement);
    $cce047a9dd9eab82$var$scene = new (0, $jw0R5.Scene)();
    $cce047a9dd9eab82$var$scene.add(new (0, $jw0R5.AmbientLight)(0xf0f0f0, 3));
    $cce047a9dd9eab82$var$camera = new (0, $jw0R5.PerspectiveCamera)(70, $cce047a9dd9eab82$var$windwoWidth / $cce047a9dd9eab82$var$windowHeight, 1, 10000);
    $cce047a9dd9eab82$var$scene.add($cce047a9dd9eab82$var$camera);
    $cce047a9dd9eab82$var$controls = new (0, $2sw9m.OrbitControls)($cce047a9dd9eab82$var$camera, $cce047a9dd9eab82$var$renderer.domElement);
    $cce047a9dd9eab82$var$controls.addEventListener('change', ()=>{
        $cce047a9dd9eab82$var$renderLoop.requestRender();
    });
    $cce047a9dd9eab82$var$stats = new (0, $82VHk.default)();
    document.body.appendChild($cce047a9dd9eab82$var$stats.dom);
    $cce047a9dd9eab82$var$motionController = new (0, $01713220afa8b7f5$export$836250ae3b3bff57)({
        frameRate: $cce047a9dd9eab82$var$FRAME_RATE,
        distance: $cce047a9dd9eab82$var$params.distance,
        duration: $cce047a9dd9eab82$var$params.duration,
        easingName: $cce047a9dd9eab82$var$params.easingName,
        easingType: $cce047a9dd9eab82$var$params.easingType,
        allowQueue: false,
        callbacks: {
            onStart: ()=>{
                $cce047a9dd9eab82$var$renderLoop.setContinuous(true);
            },
            onFinish: ()=>{
                $cce047a9dd9eab82$var$renderLoop.setContinuous(false);
                $cce047a9dd9eab82$var$renderLoop.requestRender();
            }
        }
    });
    $cce047a9dd9eab82$var$renderLoop.configure({
        fps: $cce047a9dd9eab82$var$FRAME_RATE,
        render: $cce047a9dd9eab82$var$renderFrame
    });
    $cce047a9dd9eab82$var$renderLoop.setRenderOnIdle($cce047a9dd9eab82$var$params.renderOnIdle);
    new (0, $ihXk0.GLTFLoader)().load($cce047a9dd9eab82$var$modelUrl, function(gltf) {
        const model = gltf.scene;
        $cce047a9dd9eab82$var$floors = model.children;
        $cce047a9dd9eab82$var$motionController.bindFloors($cce047a9dd9eab82$var$floors);
        $cce047a9dd9eab82$var$floorNumbers = $cce047a9dd9eab82$var$motionController.getOperableLevels();
        $cce047a9dd9eab82$var$initGUI();
        $cce047a9dd9eab82$var$scene.add(model);
        const box = new (0, $jw0R5.Box3)();
        box.setFromObject(model);
        const size = box.getSize(new (0, $jw0R5.Vector3)());
        const target = new (0, $jw0R5.Vector3)();
        const center = box.getCenter(target);
        $cce047a9dd9eab82$var$controls.target = target;
        $cce047a9dd9eab82$var$dimension.min = box.min;
        $cce047a9dd9eab82$var$dimension.max = box.max;
        $cce047a9dd9eab82$var$dimension.center = center;
        $cce047a9dd9eab82$var$dimension.size = size;
        $cce047a9dd9eab82$var$camera.position.x = center.x + 1.2 * size.x;
        $cce047a9dd9eab82$var$camera.position.y = center.y + 1 * size.y;
        $cce047a9dd9eab82$var$camera.position.z = center.z + 1.2 * size.z;
        $cce047a9dd9eab82$var$camera.updateProjectionMatrix();
        $cce047a9dd9eab82$var$controls.update();
        const light = new (0, $jw0R5.SpotLight)(0xf0f0f0, 2);
        light.position.copy($cce047a9dd9eab82$var$camera.position);
        light.position.y += 2 * size.y;
        light.lookAt(target.x, target.y, target.z);
        light.fov = 30;
        light.decay = 0.1;
        $cce047a9dd9eab82$var$scene.add(light);
        window.addEventListener('resize', ()=>{
            $cce047a9dd9eab82$var$windwoWidth = window.innerWidth;
            $cce047a9dd9eab82$var$windowHeight = window.innerHeight;
            $cce047a9dd9eab82$var$camera.aspect = $cce047a9dd9eab82$var$windwoWidth / $cce047a9dd9eab82$var$windowHeight;
            $cce047a9dd9eab82$var$camera.updateProjectionMatrix();
            $cce047a9dd9eab82$var$renderer.setSize($cce047a9dd9eab82$var$windwoWidth, $cce047a9dd9eab82$var$windowHeight);
            $cce047a9dd9eab82$var$renderLoop.requestRender();
        });
        $cce047a9dd9eab82$var$renderLoop.requestRender();
    }, function() {}, function(error) {
        console.log(error);
    });
}
function $cce047a9dd9eab82$var$initGUI() {
    const operableLevels = $cce047a9dd9eab82$var$motionController.getOperableLevels();
    const defaultLevel = operableLevels.length > 0 ? operableLevels[operableLevels.length - 1] : 0;
    const levelParams = {
        level: defaultLevel
    };
    const levelOptions = Object.fromEntries((operableLevels.length > 0 ? operableLevels : [
        defaultLevel
    ]).map((level)=>[
            String(level),
            level
        ]));
    $cce047a9dd9eab82$var$pane = new (0, $ctZJO.Pane)({
        title: 'Tower Motion'
    });
    const actionFolder = $cce047a9dd9eab82$var$pane.addFolder({
        title: 'Action'
    });
    actionFolder.addButton({
        title: 'Reset'
    }).on('click', ()=>{
        $cce047a9dd9eab82$var$reset();
    });
    actionFolder.expanded = true;
    const motionFolder = $cce047a9dd9eab82$var$pane.addFolder({
        title: 'Motion'
    });
    motionFolder.addBinding($cce047a9dd9eab82$var$params, 'distance', {
        min: 100,
        max: 3000,
        step: 10,
        label: 'Distance'
    }).on('change', (ev)=>{
        $cce047a9dd9eab82$var$motionController.setConfig({
            distance: ev.value
        });
        $cce047a9dd9eab82$var$renderLoop.requestRender();
    });
    motionFolder.addBinding($cce047a9dd9eab82$var$params, 'duration', {
        min: 0.1,
        max: 10,
        step: 0.05,
        label: 'Duration (s)'
    }).on('change', (ev)=>{
        $cce047a9dd9eab82$var$motionController.setConfig({
            duration: ev.value
        });
        $cce047a9dd9eab82$var$renderLoop.requestRender();
    });
    motionFolder.addBinding($cce047a9dd9eab82$var$params, 'easingName', {
        label: 'Easing',
        options: Object.fromEntries($cce047a9dd9eab82$var$easingNames.map((name)=>[
                name,
                name
            ]))
    }).on('change', (ev)=>{
        $cce047a9dd9eab82$var$motionController.setConfig({
            easingName: ev.value
        });
    });
    motionFolder.addBinding($cce047a9dd9eab82$var$params, 'easingType', {
        label: 'Type',
        options: {
            In: 'In',
            InOut: 'InOut',
            Out: 'Out'
        }
    }).on('change', (ev)=>{
        $cce047a9dd9eab82$var$motionController.setConfig({
            easingType: ev.value
        });
    });
    motionFolder.expanded = true;
    const renderFolder = $cce047a9dd9eab82$var$pane.addFolder({
        title: 'Render'
    });
    renderFolder.addBinding($cce047a9dd9eab82$var$params, 'renderOnIdle', {
        label: 'Render On Idle'
    }).on('change', (ev)=>{
        $cce047a9dd9eab82$var$renderLoop.setRenderOnIdle(ev.value);
    });
    renderFolder.expanded = true;
    const floorFolder = $cce047a9dd9eab82$var$pane.addFolder({
        title: 'Floors'
    });
    floorFolder.addBinding(levelParams, 'level', {
        label: 'Toggle Level',
        options: levelOptions
    }).on('change', (ev)=>{
        if ($cce047a9dd9eab82$var$motionController.isAnimating()) {
            console.log('Floors is animating!');
            return;
        }
        $cce047a9dd9eab82$var$motionController.moveToLevel(ev.value, {
            queue: false
        });
        $cce047a9dd9eab82$var$renderLoop.requestRender();
    });
    floorFolder.expanded = true;
}
function $cce047a9dd9eab82$var$renderFrame(deltaSec = $cce047a9dd9eab82$var$FRAME_DURATION) {
    const delta = Math.min(deltaSec, $cce047a9dd9eab82$var$FRAME_DURATION);
    if ($cce047a9dd9eab82$var$motionController) $cce047a9dd9eab82$var$motionController.update(delta);
    $cce047a9dd9eab82$var$stats.update();
    $cce047a9dd9eab82$var$renderer.render($cce047a9dd9eab82$var$scene, $cce047a9dd9eab82$var$camera);
}
function $cce047a9dd9eab82$var$reset() {
    if (!$cce047a9dd9eab82$var$motionController) return;
    $cce047a9dd9eab82$var$motionController.reset();
    $cce047a9dd9eab82$var$renderLoop.setContinuous(false);
    $cce047a9dd9eab82$var$renderLoop.requestRender();
}


//# sourceMappingURL=towerMotion.58ac2e26.js.map
